import React from 'react';
import { AxiosError } from 'axios';
import { useAxios } from '../Components/Auth';
import { useLogger } from '../Components/Logger';

export type Ad = {
  // product ads fields
  offer: {
    seller: {
      name: string,
      domain: string,
    },
    itemOffered: {
      description: string,
      image: {
        contentUrl: string,
        height: number,
        width: number,
      }
      name: string,
    },
    lowPrice: number,
    price: number,
    priceCurrency: string,
    priceCurrencySymbol: string,
    url: string,
  },
  shippingInfo: {
    description: string,
    price: number,
  },

  // text ads fileds
  description: string,
  displayUrl: string,
  title: string,
  url: string,
};

export type Ads = Array<Ad>;

export const useBingSerp = () => {
  const { idTokenInstance } = useAxios();
  const logger = useLogger();

  const getAds = React.useCallback(async (query: string, adTypesFilter: string): Promise<Ad[]> => {
    if (idTokenInstance) {
      try {
        const response = await idTokenInstance.get(`${process.env.REACT_APP_API_URL}/Internal/Ads?${new URLSearchParams({
          q: query,
          mkt: 'en-us',
          traffictype: 'internal_monitor',
          form: 'monitr',
          adTypesFilter, // TextAds%2CproductAds
          mainlineCount: '6',
          sidebarCount: '10',
          bottomCount: '5',
        }).toString()}`, {
          headers: {},
        });

        if (response.status !== 200) {
          // eslint-disable-next-line @typescript-eslint/no-throw-literal
          throw response;
        }

        const ads = response?.data?.value;

        return ads as Ads;
      } catch (error) {
        logger.logError(`Failue to retrive ads. Status: ${(error as AxiosError)?.response?.status}.`);

        return [] as Ads;
      }
    }

    return [];
  }, [idTokenInstance, logger]);

  return {
    getAds,
  };
};
